export function getNewTags(localTags, files) {
  if (localTags.length === 0) return [];
  return files.reduce((acc, { tags }) => {
    for (const tag of tags) {
      if (localTags.map((t) => t.name).includes(tag) && !acc.includes(tag)) {
        acc.push(tag);
      }
    }
    return acc;
  }, []);
}

export function getTagIds(allTags, tags) {
  return tags
    .map((tag) => (allTags.find((t) => t.name === tag || t.id === tag) || {}).id)
    .filter((tag) => !!tag);
}
